<template>
  <div>
    <div class="col-md-12">
      <Titulo
        description="Informe os dados necessários para realizar os cálculos da dívida."
      />
      <form class="form_padrao pt-2" action @submit.prevent="realizaCalculos">
        <div class="form-row">
          <div class="col-md-12" style="padding-top: 25px">
            <p>Dados da Dívida</p>
            <hr />
          </div>
        </div>
        <div class="form-group flutuante col-md-12">
          <input
            type="text"
            name="vlrDebito"
            id="vlrDebito"
            required
            v-model="form.vlrdebito"
          />
          <label for="vlrDebito">Valor Principal do Débito - R$</label>
        </div>
        <div class="form-group flutuante col-12">
          <input
            type="date"
            name="dataDebito"
            id="dataDebito"
            required
            v-model="form.dtdebito"
          />
          <label for="dataDebito">Data do Débito</label>
        </div>
        <div class="form-group flutuante col-md-12">
          <input
            type="date"
            name="dataCalculo"
            id="dataCalculo"
            v-model="form.dtcalculo"
            required
          />
          <label for="dataCalculo">Data de Cálculo</label>
        </div>
        <div v-if="actived">
          <div class="form-row">
            <div class="col">
              <p>Resultados Do Cálculo</p>
              <hr />
            </div>
          </div>
          <div
            class="alert alert-warning border-0 text-center mt-1 align-items-center justify-content-center position-relative"
            role="alert"
            v-if="v_calculos[0].valorcorrigido == 0"
          >
            <i class="material-icons pr-2" style="font-size: 3em">info</i>
            <p class="message">{{ mensagem }}</p>
          </div>

          <div class="form-group flutuante col-md-12">
            <input
              type="text"
              name="diasCalculo"
              id="diasCalculo"
              required
              disabled
              v-model="form.diasCalculo"
            />
            <label for="diasCalculo">Dias de Cálculo</label>
          </div>
          <div class="form-group flutuante col-md-12">
            <input
              type="text"
              name="atualizacao"
              id="atualizacao"
              required
              disabled
              v-model="form.atualizacao"
            />
            <label for="atualizacao">Atualização - R$</label>
          </div>
          <div class="form-group flutuante col-md-12">
            <input
              type="text"
              name="juros"
              id="juros"
              v-model="form.vlrJuros"
              required
              disabled
            />
            <label for="juros">Juros - R$</label>
          </div>
          <div class="form-group flutuante col-md-12">
            <input
              type="text"
              name="vlrMulta"
              id="vlrMulta"
              v-model="form.vlrMulta"
              required
              disabled
            />
            <label for="vlrMulta">Multa - R$</label>
          </div>
          <div class="form-group flutuante col-md-12">
            <input
              type="text"
              name="valorCorrigido"
              id="valorCorrigido"
              v-model="form.valorCorrigido"
              required
              disabled
            />
            <label for="valorCorrigido">Valor Corrigido - R$</label>
          </div>
        </div>

        <div class="form-row">
          <div
            class="form-group col-md-3 d-flex flex-row justify-content-end align-items-end"
            style="margin-left: 15px"
          >
            <button
              type="submit"
              class="btn btn-verde p-0 fit-content"
              :disabled="loading"
            >
              <span
                class="spinner-grow spinner-grow-sm pr-2"
                role="status"
                aria-hidden="true"
                v-show="loading"
              ></span>
              <span v-if="loading">Enviando</span>
              <span v-else>Calcular</span>
            </button>
          </div>
          <div
            class="form-group col-md-3 d-flex flex-row align-items-end"
            style="margin-left: 15px"
          >
            <button
              type="submit"
              class="btn btn-verde p-0 fit-content"
              :disabled="loading"
              @click="apagar()"
            >
              <span
                class="spinner-grow spinner-grow-sm pr-2"
                role="status"
                aria-hidden="true"
                v-show="cleaning"
              ></span>
              <span v-if="cleaning">Limpando</span>
              <span v-else>Limpar</span>
            </button>
          </div>
          {{ mensagem }}
        </div>
      </form>
      <div class="row mt-5 flex-column-reverse flex-md-row">
        <div style="padding-left: 4px padding-right: 4px margin-left: 10px">
          <Botao
            title="Voltar"
            link="/"
            nameClass="btn btn-outline-secondary btn-lg btn-block"
            >VOLTAR</Botao
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Botao from "@/components/botoes/Botao";
import Titulo from "@/components/TituloPaginas";

export default {
  name: "Calculos",
  components: {
    Botao,
    Titulo,
  },
  data() {
    return {
      produto: {
        nome: "Cálculos Econômicos",
        id: "Calculos",
      },
      loading: false,
      actived: false,
      mensagem: null,
      form: {
        atualizacao: null,
        diasCalculo: null,
        vlrJuros: null,
        vlrMulta: null,
        valorCorrigido: null,
        vlrdebito: null,
      },
      v_calculos: [],
      breadcrumb: [
        {
          nome: "Calculos",
          id: "calculos",
        },
      ],
    };
  },
  methods: {
    realizaCalculos() {

      var vlrdebito = parseFloat(this.form.vlrdebito.replace(",", "."));

      this.$http
        .get(
          "/api/CdlBh/CalcularDivida/" +
            vlrdebito +
            "/" +
            this.form.dtdebito +
            "/" +
            this.form.dtcalculo
        )
        .then((response) => {
          this.v_calculos = response.data;
          this.form.atualizacao = this.v_calculos[0].atualizacao;
          this.form.atualizacao = this.form.atualizacao.toLocaleString(
            "pt-br",
            { style: "currency", currency: "BRL" }
          );
          this.form.diasCalculo = this.v_calculos[0].diascalculo;
          this.form.vlrJuros = this.v_calculos[0].juros;
          this.form.vlrJuros = this.form.vlrJuros.toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL",
          });
          this.form.vlrMulta = this.v_calculos[0].multa;
          this.form.vlrMulta = this.form.vlrMulta.toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL",
          });
          this.form.valorCorrigido = this.v_calculos[0].valorcorrigido;
          this.form.valorCorrigido = this.form.valorCorrigido.toLocaleString(
            "pt-br",
            { style: "currency", currency: "BRL" }
          );

          this.actived = true;
        });
    },
    // realizaCalculos() {

    //         this.$http.get("/api/CdlBh/CalcularDivida/"+this.form.vlr_Debito+"/" + this.form.dtdebito +"/" + this.form.dtcalculo)
    //         .then((response) => {
    //           this.v_calculos = response.data;
    //           })

    //       if(this.vlr_Corrigido_format != null || this.vlr_Corrigido_format != "" )
    //       {
    //                 this.form.diasCalculo = "";
    //                 this.form.vlrMulta = "";
    //                 this.form.valorCorrigido = "";
    //                 this.form.vlrJuros = "";
    //       }
    //                 var dt_debito = new Date(this.form.dtdebito);
    //                 var dt_calculo = new Date(this.form.dtcalculo);
    //                 var timeDiff = Math.abs(dt_calculo.getTime() - dt_debito.getTime());
    //                 var dif_dias = Math.ceil(timeDiff / (1000 * 3600 * 24));

    //                 // var dif_dias = 50;
    //                 var vlr_Debito = this.form.vlrDebito;
    //                 var vlr_Multa = 0.02;
    //                 var vlr_Juros = (vlr_Debito * vlr_Multa)*dif_dias;
    //                 // var vlr_Juros_format = vlr_Juros.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
    //                 var vlr_Corrigido = vlr_Debito + vlr_Juros;
    //                 // var vlr_Corrigido_format = vlr_Corrigido.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
    //                 // var vlr_Debito_format = vlr_Debito.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});

    //                 this.form.diasCalculo = dif_dias;
    //                 this.form.vlrMulta = vlr_Multa * 100 +"%";
    //                 // this.form.valorCorrigido = vlr_Corrigido_format;
    //                 this.form.valorCorrigido = vlr_Corrigido;
    //                 // this.form.vlrDebito = vlr_Debito_format;
    //                 this.form.vlrJuros = vlr_Juros;
    //                 this.form.atualizacao = this.v_calculos.atualizacao;
    //  },
    apagar() {
      this.form.vlrdebito = "";
      this.form.dtdebito = "";
      this.form.dtcalculo = "";

      (this.v_calculos.atualizacao = ""),
        (this.v_calculos.diascalculo = ""),
        (this.v_calculos.juros = ""),
        (this.v_calculos.multa = ""),
        (this.v_calculos.valorcorrigido = ""),
        (this.actived = false);
    },
  },

  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
  },
};
</script>

<style lang="scss" scoped>
hr {
  color: #888 !important;
  border-color: rgb(206, 206, 206) !important;
}
.form-group.flutuante {
  position: relative;
  input[type="text"],
  input[type="number"],
  input[type="password"],
  input[type="email"],
  input[type="tel"],
  input[type="date"],
  textarea {
    width: 100%;
    background: rgba(4, 66, 142, 0.07);
    border: 0;
    outline: none !important;
    height: 55px;
    padding: 10px 25px 0;
    /*&:valid{
          border-bottom: solid 2px $secondary;
        }*/
  }
  label {
    position: absolute;
    width: 100%;
    left: 25px;
    top: 50%;
    transform: translateY(-50%);
    opacity: 0.5;
    font-size: 15px;
    pointer-events: none;
    transition: all 0.25s ease;
  }

  input:focus + label {
    top: 15px;
    font-size: 11px;
    font-weight: 500;
    opacity: 1;
  }
  input[type="number"] + label {
    top: 15px;
    font-size: 11px;
    font-weight: 500;
    opacity: 1;
  }
  input[type="text"] + label {
    top: 15px;
    font-size: 11px;
    font-weight: 500;
    opacity: 1;
  }
}
</style>
<style lang="scss">
.p-datepicker-title select {
  color: black;
  font-size: 0.8rem;
  width: auto !important;
}
.p-datepicker-title {
  display: flex !important;
}

.listBox {
  border: 0px !important;
  div {
    ul {
      background: #e5e6f1 !important;
    }
  }
}
</style>
